import { Box } from '@mui/material'
import { useEffect } from 'react'
import { setCwsDirect } from '@/features/auth/slice'
import { useAppDispatch } from '@/redux/hooks'
import LoadingMessage from '../../components/feedbacks/LoadingMessage'

export function OidcPage() {
  const dispatch = useAppDispatch()

  useEffect(() => {
    dispatch(setCwsDirect({ isOidc: true }))
  }, [])

  return (
    <Box
      sx={{
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <LoadingMessage isAuthMessage={true} />
    </Box>
  )
}
